<template>
  <vue-clip class="vue-clip-container" :options="uploadOptions" :on-complete="addedFile" :on-sending="sendingFile" >
    <template slot="clip-uploader-action" slot-scope="props">
      <div class="chat-main-container" :style="fullscreen ? 'width:100%; height:100%;' : 'width:450px; height:480px; bottom: 36px;' ">
        <!-- // drag-effect usado quando o usuário arrasta um arquivo para o chat para mostrar onde ele pode soltar o arquivo -->
        <div v-if="selectedRoom && props.dragging" class="drag-effect">
          <span>Solte o arquivo aqui!</span>
        </div>
        <p-chat-create ref="chatCreate" @create="createChat" @edit="editChat" @delete="deleteChat" @cancel="cancelChat" @loading="loadingCreateRoom"></p-chat-create>
        <v-navigation-drawer temporary absolute clipped v-model="showContacts">
          <v-list>
            <v-list-group
              v-for="(contact) in contacts"
              :key="contact[0].index"
              :value="contact[0].company_id == $auth.user().company_id"
              no-action
              appendIcon=""
              style="border-bottom: 2px solid #ccc;"
            >
              <template slot="activator">
                <v-list-tile>
                  <v-list-tile-content>
                    <div class="chat_company">
                      <span class="arrow"></span>
                      <v-list-tile-title>{{ contact[0].company_id_text }}</v-list-tile-title>
                    </div>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <div class="chat-create-btn">
                <v-btn flat outline color="teal" @click="openChatCreate(2, contact[0].company_id)">
                  <v-icon>add</v-icon>
                  <span style="margin-left: 6px">Adicionar chat/grupo</span>
                </v-btn>
                </div>

              <v-list-tile
                v-for="chatRoom in contact"
                :key="chatRoom.id"
                @click="selectRoom(chatRoom)"
                class="list-tile"
              >
                <v-list-tile-content>                 
                  <div class="chat_contact" >
                    <v-badge overlap color="#00acc200">
                      <template v-slot:badge>
                        <div v-if="chatRoom.type==3" class="badge-company">
                          <i class="fas fa-building"></i>
                        </div>                      
                        <v-icon v-else size="20" color="#00acc2">
                          {{chatRoom.type==1 ? 'account_circle' : 'supervised_user_circle'}}
                        </v-icon>
                      </template>
                      <div v-if="!chatRoom.img_path">
                        <span class="chat_group" v-if="chatRoom.type == 2">{{ getFirstLetters(chatRoom.id_text) }}</span>
                        <span class="chat_person" v-else-if="chatRoom.type == 1">{{ getFirstLetters(chatRoom.id_text) }}</span>
                        <span class="chat_company_avatar" v-else>{{ getFirstLetters(chatRoom.id_text) }}</span>
                      </div>
                      <div v-else>
                        <img class="chat_group" v-if="chatRoom.type == 2" :src="`${basePath}uploads/chats/${chatRoom.img_path}`" alt="">
                        <img class="chat_person" v-else-if="chatRoom.type == 1" :src="`${basePath}uploads/users/${chatRoom.img_path}`" alt="">
                        <img class="chat_company_avatar" v-else :src="`${basePath}uploads/companies/${chatRoom.img_path}`" alt="">
                      </div>
                    </v-badge>
                    <v-list-tile-title style="flex: 1;margin-left: 10px;">{{ chatRoom.id_text | formatAbbreviation(21) }}</v-list-tile-title>
                    <v-tooltip v-if="chatRoom.type == 2" right>
                      <template slot="activator">
                        <v-btn small flat icon color="warning" @click="openChatCreate(3, chatRoom.company_id, chatRoom.id)">
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Grupo</span>
                    </v-tooltip>
                  </div>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-navigation-drawer>

        <v-toolbar dark color="#00acc2" absolute clipped-left>
          <v-tooltip bottom>
            <v-btn slot="activator" @click.stop="openContacts" icon>
              <v-icon color="#fff">person_add</v-icon>
            </v-btn>
            <span>Contatos</span>                  
          </v-tooltip>
          <!-- // z-index adicionado pois quando esta expandido a lista não aparecia -->
          <div v-if="openSearch || !selectedRoom" class="title" :style="loadingRoom ? '' : 'z-index: 999!important'">
            <v-autocomplete :placeholder="'Digite para pesquisar'"
              color="white" v-model="selectedSearchChat" :loading="loadingSearchChat" :items="searchChats" item-text="id_text" item-value="id" @change="changeSearchChat" @click="getSearchChats" return-object :no-data-text="loadingSearchChat ? 'Carregando...' : 'Nenhum registro encontrado'" ref="searchChat"></v-autocomplete>
          </div>
          <div v-else-if="selectedRoom" class="title">
            <v-badge class="badge-type" overlap color="#fff00">
              <template v-slot:badge>
                <div v-if="selectedRoom.type==3" class="badge-company badge-company-title">
                  <i class="fas fa-building"></i>
                </div>
                <v-icon v-else size="20" color="#fff">
                  {{selectedRoom.type==1 ? 'account_circle' : 'supervised_user_circle'}}
                </v-icon>
              </template>
              <div class="avatar_title">
                <img v-if="selectedRoom.img_path" :src="`${basePath}uploads/${selectedRoom.type == 1 ? 'users' : (selectedRoom.type == 2 ? 'chats' : 'companies')}/${selectedRoom.img_path}`" alt="">
                <span v-else>{{ getFirstLetters(selectedRoom.id_text) }}</span>
              </div>
            </v-badge>

            <div class="text-selected-room">
              <h3>{{ selectedRoom.id_text | formatAbbreviation(16) }}</h3>
              <!-- // z-index adicionado pois quando esta expandido a lista não aparecia -->
              <div class="chat-members" :style="loadingRoom ? '' : 'z-index: 999!important'">
                <v-tooltip bottom>
                  <div icon slot="activator" class="text">
                    {{selectedRoom.users.length}} usuários
                  </div>
                  <v-card :max-width="500">
                    <v-list light class="others-fields">
                      <template v-for="(item, index) in selectedRoom.users">
                        <v-list-tile :key="index">
                          <v-list-tile-content>
                            <v-list-tile-title v-html="item.id_text"></v-list-tile-title>
                            <v-divider></v-divider>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-card>
                </v-tooltip>
              </div>
            </div>
          </div>
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="clickOpenSearch()">
              <v-icon>search</v-icon>
            </v-btn>
            <span>Pesquisar</span>                  
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom v-if="!$vuetify.breakpoint.smAndDown">
            <v-btn v-if="fullscreen" slot="activator" small fab icon @click="$emit('openFullscreen')"><v-icon>close_fullscreen</v-icon></v-btn>
            <v-btn v-else slot="activator" small fab icon @click="$emit('openFullscreen')"><v-icon>open_in_full</v-icon></v-btn>
            <span>{{ fullscreen ? 'Fechar tela cheia' : 'Abrir em tela cheia' }}</span>                  
          </v-tooltip>

          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="hide">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Fechar</span>                  
          </v-tooltip>
        </v-toolbar>
        <div class="chat-content">
          <div v-show="loadingRoom" class="chat-loader">
            <img :src="`${basePath}images/loader.gif`" alt="">
          </div>
          <div v-show="!hideRecents" class="recents-container">
            <span>Contatos Recentes</span>
            <div class="contacts">
              <!-- // z-index adicionado pois quando esta expandido a lista não aparecia -->
              <div class="contact"  :style="loadingRoom || showContacts || props.dragging ? '' : 'z-index: 999!important'" v-for="(recent, index) in recents" :key="index" @click="selectRoom(recent)">
                <v-tooltip bottom>
                  <template slot="activator">
                    <v-badge class="badge-type" overlap color="#00acc200">
                      <template v-slot:badge>
                        <div v-if="recent.type==3" class="badge-company">
                          <i class="fas fa-building"></i>
                        </div>
                        <v-icon v-else size="20" color="#00acc2">
                          {{recent.type==1 ? 'account_circle' : 'supervised_user_circle'}}
                        </v-icon>
                      </template>
                      <div :class="selectedRoom.id == recent.id ? 'selected-circle' : 'circle' ">
                        <div v-if="recent.type == 1">
                          <h2 v-if="!recent.img_path" class="icon">{{ getFirstLetters(recent.id_text) }}</h2>
                          <img v-else :src="`${basePath}uploads/users/${recent.img_path}`" class="icon">
                          <span v-show="recent.unseen_messages>0">{{ recent.unseen_messages }}</span>
                        </div>
                        <div v-else-if="recent.type == 2">
                          <h2 v-if="!recent.img_path" class="icon">{{ getFirstLetters(recent.id_text) }}</h2>
                          <img v-else :src="`${basePath}uploads/chats/${recent.img_path}`" class="icon">
                          <span v-show="recent.unseen_messages>0">{{ recent.unseen_messages }}</span>
                        </div>
                        <div v-else>
                          <h2 v-if="!recent.img_path" class="icon">{{ getFirstLetters(recent.id_text) }}</h2>
                          <img v-else :src="`${basePath}uploads/companies/${recent.img_path}`" class="icon">
                          <span v-show="recent.unseen_messages>0">{{ recent.unseen_messages }}</span>
                        </div>                    
                      </div>
                    </v-badge>
                  </template>
                  <span>{{ recent.id_text }}</span>
                </v-tooltip>
              </div>
            </div>
          </div>

          <div class="toggle-button">
            <div v-show="!hideRecents">
              <v-tooltip left>
                <template slot="activator">
                  <v-btn class="toggle-v-btn" dark color="#00acc2" icon @click="toggleRecents">
                    <v-icon size="12">fas fa-eye-slash</v-icon>
                  </v-btn>
                </template>
                <span>Ocultar Recentes</span>
              </v-tooltip>
            </div>
            <div v-show="hideRecents">
              <v-tooltip left>
                <template slot="activator">
                  <v-btn class="toggle-v-btn" dark color="#00acc2" icon @click="toggleRecents">
                    <v-icon size="12">fas fa-eye</v-icon>
                  </v-btn>
                </template>
                <span>Exibir Recentes</span>
              </v-tooltip>
            </div>
          </div>
          <div v-if="!selectedRoom" class="container-presentation">
            <div v-show="loadingRoom" class="chat-loader">
              <img :src="`${basePath}images/loader.gif`" alt="">
            </div>
            <span>Para começar, selecione uma conversa. ;)</span>
          </div>
          <div v-if="selectedRoom" class="messages-container" ref="msg"
            :style="`background-image: url('${basePath}images/marca-dagua.png');`">
            <div v-if="loadingMoreMsgs" class="show-more" @click="getMoreMsgs()">
              <v-progress-linear color="primary" height="2" :indeterminate="true"></v-progress-linear>
            </div>
            <div class="show-more" v-else-if="((qtdMoreMsgs * 50) < messages.length)" @click="getMoreMsgs()">
              <span><strong>Mostrar mais</strong></span>
            </div>
            <div :class="msg['user'] && $auth.user().id != msg.user.id ? 'msg others': 'msg owner'" v-for="(msg, index) in messages" :key="index" :id="'msg' + msg.id">
              <!-- // se for negativo mosta a msg carregando -->
              <div v-if="msg.id < 0">
                <span class="body-2">Você - </span>
                <span class="caption">{{ moment() | formatDateTime }}</span>
                <v-progress-circular
                  indeterminate
                  :size="20"
                  color="primary"
                ></v-progress-circular>
                <pre v-if="msg.type === 1" v-html="msg.id_text"></pre>
                <v-tooltip v-else bottom slot="activator">
                  <v-btn class="file-v-btn" slot="activator" fab small color="#00acc2">
                    <v-icon color="#fff">insert_drive_file</v-icon>
                  </v-btn>
                  <span>{{msg.id_text}}</span>
                </v-tooltip>
              </div>
              <div v-else-if="msg.id === 0">
                <span class="body-2">Você - </span>
                <span class="caption">{{ moment() | formatDateTime }}</span>
                <v-tooltip bottom>
                  <template slot="activator">
                    <v-icon color="red">error_outline</v-icon>
                  </template>
                  <span>Mensagem não enviada</span>
                </v-tooltip>
                <pre v-html="msg.id_text"></pre>
              </div>
              <div v-else-if="msg.type == 1">
                <span class="body-2">{{ $auth.user().id!=msg.user.id ? msg.user.id_text : 'Você' }} - </span>
                <span class="caption">{{ msg.created_at | formatDateTime }}</span>
                <!-- // Verrifica se o index das msgs é menos que o total menos a quantidade de msgs que não foram vistas para mostrar que nem todas foram vistas ainda -->
                <v-tooltip bottom v-if="index < (messages.length - selectedRoom.msgs_not_viewed)">
                  <template slot="activator">
                    <v-icon color="primary">done_all</v-icon>
                  </template>
                  <span>Mensagem visualizada</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template slot="activator">
                    <v-icon color="black">done</v-icon>
                  </template>
                  <span>Mensagem enviada</span>
                </v-tooltip>
                <pre v-html="msg.id_text"></pre>
              </div>
              <div v-else>
                <span class="body-2">{{ $auth.user().id!=msg.user.id ? msg.user.id_text : 'Você' }} - </span>
                <span class="caption">{{ msg.created_at | formatDateTime }}</span>

                <div class="file-msg">
                  <div class="button">
                    <div v-if="$auth.user().id!=msg.user.id">
                      <v-speed-dial v-model="fab[index]" class="speed-dial" direction="right" open-on-hover transition="slide-x-reverse-transition">
                        <v-progress-circular
                          v-if="msg.loading"
                          slot="activator"
                            :value="msg.loading_value"
                            color="primary"
                          >{{ msg.loading_value }}
                        </v-progress-circular>
                        <v-tooltip v-else bottom slot="activator">
                          <v-btn class="file-v-btn" v-model="fab[index]" slot="activator" fab small color="#00acc2" @click="downloadFile(msg)">
                            <v-icon color="#fff">{{avatarSrc(msg.extension)}}</v-icon>
                            <v-icon color="#fff">cloud_download</v-icon>
                          </v-btn>
                          <span>Baixar</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <v-btn class="file-v-btn" slot="activator" fab small color="#00acc2" @click="moveFileToIllis(msg)">
                            <v-icon color="#fff">upload_file</v-icon>
                          </v-btn>
                          <span>Adicionar ao Illis</span>
                        </v-tooltip>
                      </v-speed-dial>
                    </div>
                    <div v-else>
                      <v-speed-dial v-model="fab[index]" class="speed-dial" direction="right" open-on-hover>
                        <v-progress-circular
                          v-if="msg.loading"
                          slot="activator"
                          :value="msg.loading_value"
                          color="white"
                          >{{ msg.loading_value }}
                        </v-progress-circular>
                        <v-tooltip v-else bottom slot="activator">
                          <v-btn class="file-v-btn" v-model="fab[index]" slot="activator" fab small color="#00acc2" @click="downloadFile(msg)">
                            <v-icon color="#fff">{{avatarSrc(msg.extension)}}</v-icon>
                            <v-icon color="#fff">cloud_download</v-icon>
                          </v-btn>
                          <span>Baixar aqui</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <v-btn class="file-v-btn" slot="activator" fab small color="#fff" @click="moveFileToIllis(msg)">
                            <v-icon color="#00acc2">upload_file</v-icon>
                          </v-btn>
                          <span>Adicionar ao Illis</span>
                        </v-tooltip>
                      </v-speed-dial>
                    </div>
                  </div>
                  <div class="name">
                    "{{ msg.id_text }}.{{ msg.extension }}"
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chat-typing-div" v-if="someoneIsTyping['active']">
            <span class="chat-typing">{{someoneIsTyping['name']}} está digitando...</span>
          </div>
          
          <div class="uploader-action">
            <div v-if="selectedRoom" class="inputs-container">
              <emoji-picker v-show="!sendingMsg" @emoji="insert">
                <div
                  class="emoji-invoker"
                  slot="emoji-invoker"
                  slot-scope="{ events: { click: clickEvent } }"
                  @click.stop="clickEvent"
                >
                  <svg
                    height="24"
                    class="emoji-icon"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                    ></path>
                  </svg>
                </div>
                <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                  <div class="emoji-picker">
                    <div>
                      <div v-for="(emojiGroup, category) in emojis" :key="category">
                        <h5>{{ category }}</h5>
                        <div class="emojis">
                          <span
                            v-for="(emoji, emojiName) in emojiGroup"
                            :key="emojiName"
                            @click="insert(emoji)"
                            :title="emojiName"
                          >{{ emoji }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </emoji-picker>
              <div v-show="sendingMsg">
                <svg
                  height="24"
                  class="emoji-icon"
                  viewBox="0 0 24 24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  style="fill: #bbb"
                >
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path
                    d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                  ></path>
                </svg>
              </div>

              <div class="msg-input-container">
                <v-textarea
                  auto-grow
                  rows='1'
                  @keyup="keyupMessage"
                  :value="textMessage"
                  ref="message" id="message" 
                  :disabled="sendingMsg"
                  class="msg-input msg-text"
                  placeholder="Digite aqui..."
                  v-on:keyup.enter="sendMsg"
                  v-on:keyup.esc="hide"
                  :hide-details='true'
                  style="max-height: 100px; overflow-y: auto; margin: 6px 0;"
                ></v-textarea>
                <v-btn :loading="sendingMsg" small class="msg-send" fab color="#fff" icon @click="sendMsg">
                  <v-icon small>send</v-icon>
                </v-btn>
              </div>
              
              <div class="dz-message">
                <v-btn :disabled="sendingMsg" flat icon>
                  <v-icon>attach_file</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </vue-clip>
</template>
<script>
  /* eslint-disable no-unneeded-ternary,no-useless-escape,eqeqeq,handle-callback-err */
  import EmojiPicker from 'vue-emoji-picker'
  import general from '../../mixin/general'
  import PChatCreate from './PChatCreate'

  export default {
    components: {EmojiPicker, PChatCreate},
    mixins: [general],
    props: [ 'toggle', 'fullscreen' ],
    data () {
      return {
        // firstTimeChat recebe valor no pai, usado para identificar quando é a primeira vez e abrir o chat para o usuário no illis oferencendo ajuda
        firstTimeChat: false,
        mini: true,
        basePath: process.env.API,
        msgText: '',
        // Será o id provisorio das msgs para já adicionar antes de carregar do banco(terá numeros negativos para diferenciar do id correto)
        messageId: -1,
        someoneIsTyping: {name: '', active: false},
        setKeyup: null,
        fab: [],
        items: [],
        usersIllis: [],
        textMessage: '',
        searchContacts: '',
        recentContacts: [],
        messages: [],
        total_unseen_messages: [],
        selectedRoom: '',
        selectedSearchChat: {},
        searchChats: [],
        qtdMoreMsgs: 1,
        loadingSearchChat: false,
        openSearch: true,
        loadingMoreMsgs: false,
        showRecents: true,
        showContacts: false,
        sendingMsg: false,
        hideRecents: false,
        loadingRoom: false,
        uploadOptions: {
          url: `${process.env.API}api/add_file_chat`,
          paramName: 'file',
          maxFilesize: {
            limit: 100,
            message: '{{ filesize }} é maior que o limite máximo: {{ maxFilesize }}'
          },
          accept: (file, done) => {
            // verifica se tem alguma sala selecionada para poder continuar com o arquivo
            if (!this.selectedRoom) {
              done('File must have room')
              return null
            }
            done()
          }
        }
      }
    },
    mounted () {
      this.getAllContacts()
    },
    sockets: {
      typingMessage (name) {
        // Mostra para o usuário que tem algum digitando naquela hr
        Object.assign(this.someoneIsTyping, {name: name, active: true})
        setTimeout(() => {
          Object.assign(this.someoneIsTyping, {name: '', active: false})
        }, 5000)
      },
      msgReceived (message) {
        this.messages.push(message)
        // Coloca como não vista para depois atualizar
        this.selectedRoom['msgs_not_viewed']++
        this.updateCountMsgs()
        setTimeout(() => {
          this.$refs.msg.scrollTo(0, this.$refs.msg.scrollHeight)
        }, 100)
      },
      updateMsgsNotViewed (data) {
        if (this.selectedRoom.id === data.room_id) {
          // Se for do tipo sub, verifica se a quantidade d msgs n vistas é maior que a do parametro se for atualiza
          // Essa verificação é necessaria para chats com varios participantes para que quando um participante visualize no msm momento q outro, uma informação n sobrescreva de outro usuário
          if (parseInt(this.selectedRoom['msgs_not_viewed']) > parseInt(data.count)) {
            this.selectedRoom['msgs_not_viewed'] = parseInt(data.count)
            // O push e o pop foram feitos para atualizar a visualização nas msgs pois nãe stava atualizando
            this.messages.push({})
            this.messages.pop()
          }
        }
      },
      updateBadge (data) {
        let recentContact = this.items.find((val) => { return val.id === data.selectedRoom.id })
        // caso o usuário tenha recebido uma msg de uma sala criada, inclui a sala na lista de salas dele
        if (!recentContact) {
          this.items.unshift(data.selectedRoom)
          recentContact = this.items.find((val) => { return val.id === data.selectedRoom.id })
        }
        // Caso a sala seja uma que não esteja selecionado e o chat esteja fechado, incrementa o valor das msgs não lidas
        if (this.selectedRoom.id !== data.selectedRoom.id || !this.toggle) {
          recentContact.unseen_messages++
        } else {
          // Atualiza a sala para todas as abas do usuário quando ele abre por uma aba
          this.$socket.emit('generalEvent', {
            data: recentContact,
            responseEvent: 'updateRoom',
            room: `user${this.$auth.user().id}`
          })
        }
        recentContact.recent = new Date()
      },
      updateRoom (room) {
        let recentContact = this.items.find((val) => { return val.id === room.id })
        if (!recentContact) {
          this.items.unshift(room)
        } else {
          Object.assign(this.items.find((val) => { return val.id === room.id }), room)
        }
      }
    },
    methods: {
      keyupMessage () {
        // So manda o event se tiver passado x segundos depois do primeiro enviado
        if (this.setKeyup === null) {
          var name = this.$auth.user().id_text
          name = name.split(' ')
          this.$socket.emit('generalEvent', {
            data: name[0],
            responseEvent: 'typingMessage',
            room: `chat${this.selectedRoom.id}`
          })
          this.setKeyup = setTimeout(() => {
            clearTimeout(this.setKeyup)
            this.setKeyup = null
          }, 5000)
        }
      },
      updateCountMsgs () {
        // verifica se o chat está aberto pois se n estiver o usuário aind n terá visualizado a msg
        if (this.toggle) {
          // Atualiza o count no banco falando que aquele usuário visualizou a msg
          this.$http.post('api/update_count_msgs', {room_id: this.selectedRoom.id, user_id: this.$auth.user().id}).then((res) => {
            this.selectedRoom['msgs_not_viewed'] = parseInt(res.body)
            // O push e o pop foram feitos para atualizar a visualização nas msgs pois nãe estava atualizando
            this.messages.push({})
            this.messages.pop()
            // Atualiza as mensagens não vistas dos outros usuários quando algum já está na sala
            this.$socket.emit('generalEvent', {
              data: {count: parseInt(res.body), room_id: this.selectedRoom.id},
              responseEvent: 'updateMsgsNotViewed',
              room: `chat${this.selectedRoom.id}`
            })
          })
        }
      },
      getMoreMsgs () {
        // this.$refs.msg.scrollTo(0, this.$refs.msg.scrollHeight)scrollTop
        this.qtdMoreMsgs++
        this.loadingMoreMsgs = true
        let lastHeigthScroll = this.$refs.msg.scrollHeight
        this.$http.get(`api/chat_message?room_id=${this.selectedRoom.id}&qtd=${this.qtdMoreMsgs * 50}`).then((res) => {
          this.messages = res.body.sort((a, b) => {
            if (a.id > b.id) return 1
            if (b.id > a.id) return -1
            return 0
          })
          this.loadingMoreMsgs = false
          setTimeout(() => {
            // encontra a posição que estava quando clicou para mostrar mais
            let currentScroll = this.$refs.msg.scrollHeight - lastHeigthScroll
            this.$refs.msg.scrollTo(0, currentScroll)
          }, 200)
        })
      },
      changeSearchChat (item) {
        if (item) {
          this.selectedSearchChat = {}
          // se o id tiver o notChat significa que ele veio de um usuário não existindo o chat, portanto cria o chat com aquele usuário, se não busca o chat já existente
          if (item.notChat) {
            this.$store.commit('loader/change_dialog', true)
            let values = {
              company_id: this.$auth.user().company_id,
              users: [item]
            }
            this.$http.post('api/create_chat', values).then(
              (res) => {
                this.createChat(res.body)
                this.$store.commit('loader/change_dialog', false)
              },
              err => {
                this.$store.commit('loader/change_dialog', false)
                this.$store.commit('snackbar/change_values', {
                  text: 'Não foi possível criar o chat, reporte o erro.', color: 'error', dialog: true
                })
              })
          } else {
            this.selectRoom(item)
          }
        }
      },
      clickOpenSearch (val = !this.openSearch) {
        this.openSearch = val
        // Busca os registros de chat ao clicar
        this.getSearchChats()
        setTimeout(() => {
          if (this.openSearch || !this.selectedRoom) this.$refs.searchChat.focus()
        }, 200)
      },
      getSearchChats (item) {
        // caso ja tenho sido pesquisado os usuário não pesquisa novamente
        this.loadingSearchChat = true
        if (this.searchChats.length === 0) {
          this.$http.get(`api/get_users_illis_company`).then((res) => {
            this.usersIllis = res.body
            this.mountListUsersChat()
          }, (err) => {
            this.loadingSearchChat = false
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível buscar os registros.', color: 'error', dialog: true})
          })
        } else {
          this.mountListUsersChat()
        }
      },
      mountListUsersChat () {
        this.searchChats = JSON.parse(JSON.stringify(this.items))
        // verifica se algum usuário da empresa já não está no chat. caso não esteja ele é adicionado
        this.usersIllis.map((val) => {
          if (!this.items.some((item) => {
            return item.type == 1 && `${item.user_id}-${item.company_id}` == val.id
          })) {
            val['notChat'] = true
            this.searchChats.push(JSON.parse(JSON.stringify(val)))
          }
        })
        // Ordena a lista de usuário
        this.searchChats = this.searchChats.sort((a, b) => {
          if (a.id_text > b.id_text) return 1
          if (b.id_text > a.id_text) return -1
          return 0
        })
        this.loadingSearchChat = false
      },
      // variavel alreadyExistChat para identifcar se o chat já existe, pois se já existir so abre ele
      createChat (room, alreadyExistChat = false) {
        if (!alreadyExistChat) {
          this.items.unshift(room)
        }
        this.selectRoom(room)
      },
      editChat (room) {
        let editedRoom = this.items.find((val) => { return val.id === room.id }) || {}
        Object.assign(editedRoom, room)
        // se a sala editada for a selecionada, altera os valores dela tbm
        if (this.selectedRoom.id === editedRoom.id) this.selectedRoom = editedRoom
      },
      deleteChat (roomId) {
        this.items.splice(this.items.findIndex((val) => {
          return val.id === roomId
        }), 1)
      },
      hide (event) {
        this.$emit('toggle', false)
      },
      moveFileToIllis (msg) {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post(`api/add_file_from_chat/${msg.id}`).then((res) => {
          // Enviando evento via Socket.io para atualizar a lista de arquivos
          // para os usuários que estiverem na tela de arquivos
          this.$socket.emit('generalEvent', {
            data: res.body,
            responseEvent: 'addSocketItem',
            notBroadcast: true,
            room: `files${this.$auth.user().company_id}`
          })
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', { text: 'Arquivo adicionado com sucesso!', color: 'success', dialog: true })
        },
        error => {
          console.log('error', error)
          this.$store.commit('loader/change_dialog', false)
          if (error.body.message.includes('limit|')) {
            // tratamento de erro caso o limite do plano seja atingido
            this.$store.commit('snackbarPlan/change_values', {
              text: `Não foi possível incluir o arquivo!`,
              dialog: true
            })
            // busca a memoria do plano do usuário
            let sizePlan = this.$store.getters[`plan/accesses`].find((res) => {
              return (res.id_text === 'files' && res.hasOwnProperty('size'))
            })
            // caso não tenha a variavel de tamanho, insere 0
            sizePlan = !sizePlan ? 0 : sizePlan['size']
            // transforma bit em mb
            let sumSizeFiles = (parseInt(sizePlan) - parseInt(error.body.message.split('|')[1])) / 1000000
            this.$store.commit('dialogPlan/change_values', {
              title: 'Memória excedida',
              text: `Esse arquivo ultrapassa o limite do seu plano, você tem apenas <strong>${Math.round(sumSizeFiles)}mb disponível</strong>. Aproveite e faça o upgrade agora mesmo!`,
              showDialog: true
            })
          }
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de arquivo.', color: 'error', dialog: true})
        })
      },
      avatarSrc (extension) {
        switch (extension) {
          case 'pdf': return 'picture_as_pdf'
          case 'png': case 'jpg': case 'jpeg': case 'gif': return 'image'
          case 'docx': case 'rtf': return 'description'
          case 'mp4': return 'videocam'
          default: return 'insert_drive_file'
        }
      },
      downloadFile (item) {
        // seta true para o loading começar a rodar
        this.$set(item, 'loading', true)
        this.$set(item, 'loading_value', 0)
        this.$http.get(`api/chat_message/download/${item.id}`, {responseType: 'arraybuffer',
          progress (e) {
            if (e.lengthComputable) {
              item.loading_value = Math.floor(e.loaded / e.total * 100)
            }
          }
        }).then((res) => {
          let blob = new Blob([res.data], {type: res.headers.get('content-type')})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${item.id_text}.${item.extension}`
          link.click()
          item['loading'] = false
        }, err => {
          console.log(err)
          item['loading'] = false
        })
      },
      addedFile (file, status, xhr) {
        if (status != 'error') {
          let fileMessage = JSON.parse(xhr.response)
          // edita
          Object.assign(this.messages.find((val) => { return val.id == fileMessage.id_old }), fileMessage)
          this.afterSendMsg(fileMessage)
        }
      },
      sendingFile (file, xhr, formData) {
        // Adiciona o loading do botão de envio
        this.sendingMsg = true
        let messageId = this.messageId - 1
        // Usado o id_old para identificar o registro depois para alterar os valores
        formData.append('id_old', messageId)
        formData.append('user_id', this.$auth.user().id)
        formData.append('room_id', this.selectedRoom.id)
        formData.append('company_id', this.selectedRoom.company_id)
        formData.append('size', file.size)
        formData.append('type', 2)
        let sentMsg = {
          id: messageId,
          id_text: formData.name,
          user_id: this.$auth.user().id,
          room_id: this.selectedRoom.id,
          uploading: true,
          company_id: this.selectedRoom.company_id,
          type: 2 // type 1 = text message, type 2 = file
        }
        this.messages.push(sentMsg)
        // Para que a msg fique como não visualizada até ser visualizada
        this.selectedRoom.msgs_not_viewed++
        // Faz a rolagem para o fim da conversa e foca no campo de msg
        setTimeout(() => {
          this.$refs.msg.scrollTo(0, this.$refs.msg.scrollHeight)
          if (this.$refs.message) {
            this.$nextTick(() => this.$refs.message.focus())
          }
        }, 100)
        // Remove o loading do botão de envio
        this.sendingMsg = false
      },
      openContacts () {
        this.showContacts = !this.showContacts
        this.showRecents = !this.showRecents
      },
      insert (emoji) {
        this.textMessage = document.getElementById('message').value + emoji
      },
      toggleRecents () {
        this.hideRecents = !this.hideRecents
      },
      afterSendMsg (resBody) {
        // Envia o evendo para o servidor Socket para que os outros participantes da conversa recebam a mensagem em tempo real
        this.$socket.emit('generalEvent', {
          data: resBody,
          responseEvent: 'msgReceived',
          room: `chat${this.selectedRoom.id}`
        })
        var values = JSON.parse(JSON.stringify(this.selectedRoom))
        // Depois que envia a msg ve se o chat for individual troca a imagem e o nome para enviar pra adicionar no outro usuário
        if (values.type === 1) {
          values['img_path'] = this.$auth.user().photo_path
          values['id_text'] = this.$auth.user().id_text
        }
        // Faz um loop pelo array de participantes da conversa para enviar para cada um deles os eventos que atualizarão os badges
        resBody.users.forEach((val) => {
          if (this.$auth.user().id !== val.user_id) {
            // Muda o company_id para a compania do usuário que terá o chat recebido
            values = Object.assign(values, {'company_id': val.company_id})
            // Evento que atualiza os badges
            this.$socket.emit('generalEvent', {
              data: {
                quantity: 1,
                type: 'add',
                recent: resBody.created_at,
                selectedRoom: values
              },
              responseEvent: 'updateBadge',
              room: `user${val.user_id}`
            })
            // Evento que atualiza os totais do badge pois o pChat por estar no dialog não mostra
            this.$socket.emit('generalEvent', {
              data: {
                type: 'add',
                selectedRoom: {id: values['id']}
              },
              responseEvent: 'updateTotalBadge',
              room: `user${val.user_id}`
            })
          }
        })

        // Para atualizar a lista de contatos recentes, tentamos encontrar a sala selecionada na lista de recentes
        let room = this.items.find((val) => { return val.id === this.selectedRoom.id })
        // Se encontrar, somente atualiza o atributo "recent" para que a lista seja reordenada
        room.recent = resBody.created_at
      },
      sendMsg () {
        if (this.sendingMsg) {
          // Verifica se já está enviando uma mensagem
          this.$store.commit('snackbar/change_values', {
            text: 'Aguarde o envio da mensagem anterior.', color: 'warning', dialog: true
          })
        } else if (!document.getElementById('message').value) {
          // Verifica se o usuário digitou alguma mensagem ou selecionou alguma sala
          this.$store.commit('snackbar/change_values', {
            text: 'Você deve digitar uma mensagem.', color: 'warning', dialog: true
          })
        } else {
          // Se tiver digitado a mensagem e selecionado a sala, segue o processo para o envio de mensagens
          // Adiciona o loading do botão de envio
          this.sendingMsg = true
          // insere link em todos os links digitados
          var mgsText = document.getElementById('message')
          // regex para pesquisar os links
          var regex = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi
          mgsText.value = mgsText.value.replace(regex, (url) => {
            // Substitui todas a palavras de link por link e verifica se precisa adicionar o https antes, pois se não for com o http n entra no link certo
            return `<a target="_blank" href="${!url.includes('http') ? 'https://' : ''}${url}">${url}</a>`
          })
          let sentMsg = {
            id: this.messageId--,
            id_text: mgsText.value,
            user_id: this.$auth.user().id,
            room_id: this.selectedRoom.id,
            company_id: this.selectedRoom.company_id,
            // participants: this.selectedRoom.participants,
            type: 1 // type 1 = text message, type 2 = file
          }
          // Para que a msg fique como não visualizada até ser visualizada
          this.selectedRoom.msgs_not_viewed++
          this.messages.push(sentMsg)
          // Ao trocar pro textarea essas duas variaveis do data do textarea não permitiam o valor ser apagado e foi necessário apagar elas também
          this.$refs.message.initialValue = ''
          this.$refs.message.lazyValue = ''
          mgsText.value = ''
          mgsText.style.height = '33px'
          // Faz a rolagem para o fim da conversa e foca no campo de msg
          setTimeout(() => {
            this.$refs.msg.scrollTo(0, this.$refs.msg.scrollHeight)
            if (this.$refs.message) {
              this.$nextTick(() => this.$refs.message.focus())
            }
          }, 100)
          // Remove o loading do botão de envio
          this.sendingMsg = false
          this.$http.post('api/chat_message', sentMsg).then((res) => {
            // Adiciona ao array de mensagens e limpa o campo de texto
            Object.assign(this.messages.find((val) => { return val.id === sentMsg.id }), res.body)
            // envia todos os sockets depois que inclui a mensagem
            this.afterSendMsg(res.body)
          },
          err => {
            console.log(err)
            // informa que a msg n foi enviada
            Object.assign(this.messages.find((val) => { return val.id === sentMsg.id }), {id: 0})
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível Enviar a última mensagem.',
              color: 'error',
              dialog: true
            })
          })
        }
      },
      selectRoom (contact) {
        this.loadingRoom = true
        this.showContacts = false
        this.$http.get(`api/get_chat_messages/${contact.id}`).then((res) => {
          this.openSearch = false
          // inserido em alguma sala: se sim, removemos dessa sala e inserimos na nova sala selecionada.
          if (this.selectedRoom) {
            this.$socket.emit('leaveRoom', { room: `chat${this.selectedRoom.id}` })
          }
          this.messages = res.body['messages'].sort((a, b) => {
            if (a.id > b.id) return 1
            if (b.id > a.id) return -1
            return 0
          })
          this.selectedRoom = JSON.parse(JSON.stringify(contact))
          this.selectedRoom['users'] = res.body['users']
          this.selectedRoom['msgs_not_viewed'] = res.body['msgs_not_viewed']
          // Atualiza todos as msgs visualizadas das pessoas que estão no msm chat
          this.updateCountMsgs()
          this.$socket.emit('joinRoom', { room: `chat${this.selectedRoom.id}` })
          // Busca o contato na lista de recentes
          let recent = this.items.find((val) => { return val.id === contact.id })
          this.loadingRoom = false
          // Faz a rolagem para o fim da conversa e Foca no campo de mensagem depois que seleciona a sala
          setTimeout(() => {
            let currentScroll = 0
            // Se for selecioando uma sala já existente faz processamento para atualizar a sala
            if (recent) {
              // Atualiza a sala para todas as abas do usuário quando ele abre por uma aba
              this.$socket.emit('generalEvent', {
                data: recent,
                responseEvent: 'updateRoom',
                room: `user${this.$auth.user().id}`
              })
              // Atualiza quando o usuário abre uma aba, atualiza as msgs não vistas
              this.$socket.emit('generalEvent', {
                notBroadcast: true,
                responseEvent: 'getTotalUnseenMessages',
                room: `user${this.$auth.user().id}`
              })
              recent['users'] = res.body['users']
              // verifica se existe msgs não lidas
              if (recent['unseen_messages'] && recent['unseen_messages'] > 0) {
                let size = 0
                // se as msgs não lidas forem maior ou igual ao total d emsgs, já vai pro inicio da conversa
                if (recent['unseen_messages'] >= this.messages.length) {
                  currentScroll = this.$refs.msg.scrollHeight
                } else {
                  // faz um for para pegar as mesgs não lidas e ir somando o tamanho delas
                  for (var i = 1; i <= recent['unseen_messages']; i++) {
                    // para pegar o id das ultimas msgs e ver o tamanho delas no chat
                    let id = this.messages[this.messages.length - i].id
                    size = document.getElementById(`msg${id}`).offsetHeight
                    // vai somando o tamanho das msgs não vistas para colocar o scroll na posição sa ultima não vista
                    currentScroll += size
                  }
                  // pega o tamanho do componente pois a barra precisa desconsiderar ele
                  size = document.getElementsByClassName(`messages-container`)[0].offsetHeight
                  currentScroll += (size / 2)
                }
              }
              // se encontrar o recent, zera o "unseen_messages" do contato para ser atualizado na lista de contatos recentes
              recent['unseen_messages'] = 0
            }

            // pega o talmanho total do scroll do chata e tira o valor do tamanhos das mensagens não vistas
            this.$refs.msg.scrollTo(0, this.$refs.msg.scrollHeight - currentScroll)
            if (this.$refs.message) {
              this.$nextTick(() => this.$refs.message.focus())
            }
          }, 200)
        })
      },
      getAllContacts () {
        // Busca todos os contatos no banco de dados
        this.loadingRoom = true
        this.$http.get(`api/chat_contacts`).then((res) => {
          this.items = res.body
          this.loadingRoom = false
          if (this.firstTimeChat) {
            this.firstTimeChat = false
            // verifica se existe chat com a illis para Entrar direto no chat do illis
            let chatIllis = this.items.find((item) => { return item.user_id === 19 })
            // Quando for mobile não mostra o chat
            if (chatIllis && !this.$vuetify.breakpoint.smAndDown) {
              // Abre o chat com a illis
              this.selectRoom(chatIllis)
            } else {
              // caso não encontre um chat com o illis, fecha o chat
              this.hide()
            }
          }
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível buscar os contatos do chat. Favor recarregar a página ou reportar o erro!',
            color: 'error',
            dialog: true
          })
        })
      },
      cancelChat () {
        this.showContacts = false
      },
      loadingCreateRoom (val) {
        this.loadingRoom = val
      },
      openChatCreate (view, companyId = '', roomId = null) {
        this.showContacts = false
        this.loadingRoom = true
        this.$refs.chatCreate.openDialog(view, companyId, roomId)
      }
    },
    watch: {
      toggle (val) {
        if (val) {
          // caso já tenha alguma sala selecionada quando o usuário entra no chat, zera as msgs n lidas daquela sala
          if (this.selectedRoom['id'] > 0) {
            // caso tenha uma sala selecionada, mostra o usuário no titulo
            this.openSearch = false
            // atualiza as msgs não visualizadas quando o usuário não estava no chat mas abre o chat e a sala já estava aberta
            this.updateCountMsgs()
            let recentContact = this.items.find((val) => { return val.id === this.selectedRoom.id })
            // Faz a rolagem para o fim da conversa e foca nas mensagens depois que entra no chat com alguma sala aberta
            setTimeout(() => {
              this.$refs.msg.scrollTo(0, this.$refs.msg.scrollHeight)
              if (this.$refs.message) {
                this.$nextTick(() => this.$refs.message.focus())
              }
            }, 500)
            setTimeout(() => {
              recentContact.unseen_messages = 0
              // Atualiza a sala para todas as abas do usuário quando ele abre por uma aba
              this.$socket.emit('generalEvent', {
                data: recentContact,
                responseEvent: 'updateRoom',
                room: `user${this.$auth.user().id}`
              })
            }, 2000)
          } else {
            this.clickOpenSearch()
          }
        }
      }
    },
    computed: {
      // busca todos os contatos e agrupa eles por empresa
      contacts () {
        var contacts = []
        // filtra os itens de acordo o nome do chat ou da empresa com o pesquisa
        var items = JSON.parse(JSON.stringify(this.items.filter((item) => {
          let itemText = item.company_id_text + item.id_text
          const hasValue = val => val != null ? val : ''
          const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          const search = hasValue(this.searchContacts).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          return text.indexOf(search) > -1
        })))
        // Ordena os registros levando em consideração o nome da empresa e o nome do usuário
        var sortItem = items.sort((a, b) => {
          if ((a.company_id_text.toUpperCase() + a.company_id + a.id_text.toUpperCase()) < (b.company_id_text.toUpperCase() + b.company_id + b.id_text.toUpperCase())) {
            return -1
          }
          if ((a.company_id_text.toUpperCase() + a.company_id + a.id_text.toUpperCase()) > (b.company_id_text.toUpperCase() + b.company_id + b.id_text.toUpperCase())) {
            return 1
          }
          return 0
        })
        // CAlcula o total_unseen_messages para mandar pro badge que mostra o total msgs n vistas
        // this.total_unseen_messages = 0
        var index = -1
        var beforeCompanyId = 0
        sortItem.map((item) => {
          if (beforeCompanyId !== item.company_id) {
            index++
            beforeCompanyId = item.company_id
          }
          // this.total_unseen_messages = parseInt(this.total_unseen_messages) + parseInt(item.unseen_messages)
          if (typeof contacts[index] === 'undefined') contacts[index] = []
          contacts[index].push(item)
        })
        // this.$emit('updateTotalUnseenMessages', this.total_unseen_messages)
        return contacts
      },
      // Pega todos os grupos que possuem mensagem e colocam eles em ordem de recentes
      recents () {
        return this.items.sort((a, b) => {
          return Date.parse(b.recent) - Date.parse(a.recent)
        })
      }
    }
  }
</script>

<style scoped>
  .badge-type{
    margin-top: 10px;
  }

  .badge-company{
    background: #00acc2;
    color: #fff;
    font-size: 0.8em;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .badge-company-title{
    background: #fff;
    color: #00acc2;
  }

  .others-fields a {
    height: 25px !important;
  }
  
   .list-tile{
    margin: 0 6px;
  }

  .arrow:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #999;
    border-right: none;
  }

  .v-list__group--active .arrow:before{
    border-bottom: none;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #999;
  }

  .chat-create-btn {
    margin: 0 6px;
    border-top: 1px solid #ccc;
  }

  .chat_company{
    display: flex;
    align-items: center;
  }

  .chat_company::before{
    display: flex;
    align-items: center;
    margin-left: 24px;
  }

  .avatar {
    width: 40px !important;
    height: 40px !important;
    border: 2px solid #024b7c;
    margin-right: 6px;
  }

  .avatar img {
    width: 25px;
    height: 25px;
  }

  .chat_company .text span,
  .chat_contact span.chat_person,
  .chat_contact span.chat_group,
  .chat_contact span.chat_company_avatar{
    background: #ddd;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    width: 35px;
    height: 35px;
    align-items: center;
  }

  .chat_contact span.chat_person,
  .chat_contact span.chat_group,
  .chat_contact span.chat_company_avatar{
    margin-right: 4px;
    padding: 2px 4px;
    font-size: 0.8em;
  }

  .chat_contact span.chat_person,
  .chat_contact span.chat_group,
  .chat_contact span.chat_company_avatar,
  .chat_contact img.chat_person,
  .chat_contact img.chat_group,
  .chat_contact img.chat_company_avatar{
    background: #ddd;
    border: 2px solid #999;
  }

  .chat_contact img{
    margin-right: 4px;
    border-radius: 50%;
    height: 35px;
    width: 35px;
  }

  .chat_contact{
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 8px;
    width: 100%;
  }

  .chat-main-container{
    background-color:#F5F5F5;
    border: 1px solid #024b7c;
    overflow: hidden;
    position: fixed;
    right: 0;
    z-index: 3;
  }
  
  /* // quando o arquivo é colocado em cima do chat, mostra uma escrita para indicar ao usuário pra ele soltar o arquivo */
  .drag-effect{
    display: flex;
    z-index: 4;
    width: 100%;
    height: 100%;
    background: #000000b8;
    position: absolute;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-weight: bold;
    color: white;
  }
  /* .vue-clip-container{
    width:400px;
    height:280px;
  } */

  .contacts{
    display: flex;
    align-items: center;
  }

  .contacts .avatar{
    background: #ccc;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 6px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title{
    display: flex;
    align-items: center;
  }

  .title::before{
    content: '';
    height: 40px;
    width: 2px;
    background: #fff;
    margin-right: 10px;
    margin-left: 8px;
  }

  .title .avatar_title{
    color: #fff;
    width: 45px;
    height: 45px;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;

    background: #ddd;
    border-radius: 50%;
    color: #333;
  } 

  .title .avatar_title img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .title .text-selected-room{
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: start;
    margin-left: 12px;
  }

  .title .text-selected-room h3{
    font-size: 0.8em;
  }

  .title .chat_group{
    border: 3px solid #009e54;
    background: #ddd;
  }

  .title .chat_company_avatar{
    border: 3px solid #7c0272;
    background: #ddd;
  }

  .title .text{
    font-size: 0.6em;
  }

  .chat-loader{
    width: 100%;
    height: 100%;
    background: #00000090;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chat-loader img{
    width: 80px;
    height: auto;
  }

  .container-presentation{
    display: flex;
    align-content: center;
    justify-content: center;
    text-align: center;
    height: 100%;
  }

  .container-presentation span{
    font-size: 24px;
    font-weight: bold;
    margin: auto;
  }

  .chat-content{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 70px 10px 10px 10px;
    height: 100%;
  }

  .chat-content .recents-container{
    display: flex;
    flex-direction: column;
  }

  .chat-content .recents-container span{
    font-size: 0.8em;
    color: #47555e;
  }

  .chat-content .recents-container .contacts{
    display: flex;
    overflow-x: auto;
    position: relative;
  }

  .chat-content .recents-container .contact{
    padding: 0 4px 2px;
    cursor: pointer;
  }

  .chat-content .recents-container .selected-circle,
  .chat-content .recents-container .circle{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    color: #fff;
  }

  .chat-content .recents-container .selected-circle{
    background: #00acc2;
  }

  .chat-content .recents-container .circle{
    background: #999;
  }

  .chat-content .recents-container .icon{
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
  }

  .chat-content .recents-container .selected-circle span,
  .chat-content .recents-container .circle span{
    position: absolute;
    bottom: 0;
    right: -8px;
    display: block;
    background: #00acc2;
    padding: 0 6px;
    border-radius: 50%;
    color: #fff;
    font-size: 1.2em;
  }

  .chat-content .toggle-button{
    position: absolute;
    top: 60px;
    right: 0;
  }

  .chat-content .toggle-button .toggle-v-btn{
    height: 20px;
    width: 20px;
  }

  .chat-content .messages-container{
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    flex: 1;
    margin: 6px 0;    
    background-position: center;
    background-repeat: no-repeat;
  }

  .chat-content .messages-container {
    overflow-x: hidden;
    border: 1px solid #d1d1d1;
    padding: 8px;
    border: 1px solid #024b7c;
    border-radius: 5px;
  }

  .chat-content .messages-container .msg{
    border-radius: 5px;
    padding: 4px 10px;
    margin-bottom: 8px;
    text-align: left;
  }

  .chat-content .messages-container .others{
    border: 1px solid #888;
    margin-right: 20px;
    background: #fff;
  }

  .chat-content .messages-container .owner{
    border: 1px solid #024b7c;
    margin-left: 20px;
    background: #015d69;
    color: #fff;
  }

  .chat-content .messages-container .others pre,
  .chat-content .messages-container .owner pre{
    margin: 0;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", 
      Helvetica, Arial, "Lucida Grande", sans-serif;
  }

  .chat-content .messages-container .file-msg{
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    padding: 6px;
  }

  .chat-content .messages-container .file-msg .button{
    display: flex;
    align-content: center;
    justify-content: center;
    padding: 6px;
  }

  .chat-content .messages-container .file-msg .button .file-v-btn{
    margin: 0 4px;
  }

  .chat-content .messages-container .file-msg .name{
    display: flex;
    word-break: break-all!important;
    /* word-wrap: break-word ; */
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

  .chat-content .inputs-container{
    display: flex;
    background-color: #d1d1d1;
    align-items: center;
    justify-content: space-between;
  }

  .chat-content .inputs-container .msg-input-container{
    position: relative;
    flex: 1;
  }

  .chat-content .inputs-container .msg-input-container .msg-text {
    border-radius: 15px;
    background-color: white;
    width: 100%;
    padding: 4px 40px 4px 8px;
    outline: 0;
    resize: none;
  }

  #message{
    max-height: 30px !important;
  }

  .chat-typing-div{
    display: flex;
    justify-content: center;
    width: 100%;
    height: 16px;
    vertical-align: top !important;
    bottom: 70px;
    position: absolute;
  }
  
  .chat-typing{
    min-width: 200px;
    height: 16px;
    vertical-align: top !important;
    background-color: #f5f5f5;
    border-radius: 20px 20px 0px 0px;
  }

  .chat-content .inputs-container .msg-input-container .msg-send {
    position: absolute;
    top: 50%;
    /* right: 2px; incluido para quando o texto crai barra de rolagem, pro icone não sobrepor a barra */
    right: 2px;
    transform: translateY(calc(-50% - 6px));
    height: 36px;
    width: 36px;
}


  .emoji-invoker {
    position: relative;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
  }

  .emoji-invoker:hover {
    transform: scale(1.1);
  }

  .emoji-invoker > svg {
    fill: #8a9093;
  }

  .emoji-picker {
    position: absolute;
    z-index: 1;
    font-family: Montserrat;
    border: 1px solid #ccc;
    width: 15rem;
    height: 20rem;
    overflow: scroll;
    padding: 1rem;
    box-sizing: border-box;
    border-radius: 0.5rem;
    background: #fff;
    box-shadow: 1px 1px 8px #c7dbe6;
    bottom: 20px;
    margin-bottom: 40px;
  }

  .emoji-picker__search {
    display: flex;
  }

  .emoji-picker__search > input {
    flex: 1;
    border-radius: 10rem;
    border: 1px solid #ccc;
    padding: 0.5rem 1rem;
    outline: none;
  }

  .emoji-picker h5 {
    margin-bottom: 0;
    color: #b1b1b1;
    text-transform: uppercase;
    font-size: 0.8rem;
    cursor: default;
  }

  .emoji-picker .emojis {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .emoji-picker .emojis:after {
    content: "";
    flex: auto;
  }

  .emoji-picker .emojis span {
    padding: 0.2rem;
    cursor: pointer;
    border-radius: 5px;
  }

  .emoji-picker .emojis span:hover {
    background: #ececec;
    cursor: pointer;
  }

  .emoji-icon {
    /* position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
    margin: 6px 8px 0;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/shared/PChat.vue